<template>
  <router-link to="/klantenservice" class="text-[--color-accent-600] hover:text-[--color-accent-700]">
    {{ $t("common.links.contact_administrator") }}
  </router-link>
</template>
